module.exports = __webpack_public_path__ + "static/img/review_brand_right_top.1c29226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/review_brand_right_top.png
// module id = y8Ix
// module chunks = 2